import ListView from "./ListView/ListView";

const Member = {
  ListView,
};

export default Member;
